// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.intervention.PredictiveInterventionAttributeRequest */
/* istanbul ignore next */
@GandalfModel
export class PredictiveInterventionAttributeRequest extends GandalfModelBase {

	@GandalfLabel('Reference Data')
	@GandalfValidator({ notNull: { message: 'Reference Data is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	nameReferenceDataId!: number;

	@GandalfLabel('Value')
	@GandalfValidator({ sizeString: { message: 'Value cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	value!: string | null;

}
